import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Methodology from "./pages/Methodology";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import HeightImperial from "./pages/HeightImperial";
import HeightMetric from "./pages/HeightMetric";
import SiteHeader from "@/components/layout/SiteHeader";
import SiteFooter from "@/components/layout/SiteFooter";
import AverageMaleHeightUS from "./pages/AverageMaleHeightUS";
import AverageFemaleHeightUS from "./pages/AverageFemaleHeightUS";
import USHeightDistribution from "./pages/USHeightDistribution";
import About from "./pages/About";
import Sources from "./pages/Sources";
import Contact from "./pages/Contact";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <SiteHeader />
        <Routes>
          <Route path="/" element={<Index />} />
          {/* SEO landing pages for height queries */}
          <Route path=":" element={<NotFound />} />
          <Route path="/:sex/:feetFt-:inchIn-percentile" element={<HeightImperial />} />
          <Route path="/:sex/:cm-cm-percentile" element={<HeightMetric />} />

          {/* Evergreen content */}
          <Route path="/average-male-height-us" element={<AverageMaleHeightUS />} />
          <Route path="/average-female-height-us" element={<AverageFemaleHeightUS />} />
          <Route path="/us-height-distribution" element={<USHeightDistribution />} />
          <Route path="/about" element={<About />} />
          <Route path="/sources" element={<Sources />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/methodology" element={<Methodology />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <SiteFooter />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
